import createSvgIcon from '../Utils/CreateSvgIcon';

export const Trend = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M18.68 7.46 17 7.47v-2l3.97-.024 1-.006V10.41l-2 .012V9.011l-7.126 7.76-.722.787-.738-.772-2.92-3.053-4.741 4.958-.692.723-1.445-1.382.691-.723 5.464-5.714.723-.756.723.756 2.905 3.038L18.68 7.46Z"
    fillRule="evenodd"
  />,
  'Trend',
);
